module.exports = __webpack_public_path__ + "images/embed/arrow_right.png";